import { createRoute, dynamicWrapper } from '@/utils/core';

const routesConfig = (app) => ({
    path: '/navigation/index',
    title: '导航',
    component: dynamicWrapper(app, [], () => import('./components'))
});

export default (app) => createRoute(app, routesConfig);
